import CaseMix from "./CaseMix";
import ConsultationLineChartWithFilter from "./ConsultationLineChartWithFilter";
import Dashboard from "./Dashboard";
import OnTimeStartDelay from "./OnTimeStartDelay";
import SummaryCards from "./SummaryCards";
import TopConsultationsChart from "./TopConsultationsChart";
import UtilizationCapacity from "./UtilizationCapacity";
import VetShiftSchedule from "./VetShiftSchedule";
import VetSpecializationPieChart from "./VetSpecializationPieChart";

function Main() {
  return (
    <div className="App">
      <div style={{ padding: "30px", background: "#f8f9fb" }}>
        <SummaryCards />

        <div style={{ padding: "30px 0px", background: "#f9fafc" }}>
          <ConsultationLineChartWithFilter />
        </div>

        <div style={{ padding: "30px 0px", background: "#f9fafc" }}>
          <div
            style={{
              display: "flex",
              gap: "24px",
              // padding: "24px",
              background: "#f8f9fb",
            }}
          >
            <div
              style={{
                flex: 1,
                backgroundColor: "#ffffff",
                borderRadius: "12px",
                padding: "24px",
                boxShadow: "0 2px 8px rgba(0, 0, 0, 0.08)",
                border: "1px solid #e5e7eb",
              }}
            >
              <TopConsultationsChart />
            </div>
            <div
              style={{
                flex: 1,
                backgroundColor: "#ffffff",
                borderRadius: "12px",
                padding: "24px",
                boxShadow: "0 2px 8px rgba(0, 0, 0, 0.08)",
                border: "1px solid #e5e7eb",
              }}
            >
              <VetSpecializationPieChart />
            </div>
          </div>
        </div>
        <div style={{ padding: "30px 0px", background: "#f9fafc" }}>
          <UtilizationCapacity />
        </div>
        <div style={{ padding: "30px 0px", background: "#f9fafc" }}>
          <OnTimeStartDelay />
        </div>
        <div style={{ padding: "30px 0px", background: "#f9fafc" }}>
          <CaseMix />
        </div>

        {/* <div style={{ padding: '30px 0px', background: '#f9fafc', }}>
   <Dashboard />
   </div>  */}
        {/* <VetShiftSchedule /> */}
      </div>
    </div>
  );
}

export default Main;
